/* istanbul ignore file */
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserReadFacade } from 'redux/user-read/user-read.facade';
import { setLocalStorageReturnUrl } from 'utils/FpLocalStorage/local-storage';

export type FpAuthProps = {}

/**
 * X-grabの認証認可を通った場合のみコンテンツを表示するコンポーネント.
 */
export const FpAuthGuard = (props: FpAuthProps) => {
  const { loggedIn } = useUserReadFacade();
  const handleGuard = () => {
    if (!loggedIn) {
      setLocalStorageReturnUrl(`${window.location.pathname}${window.location.search}`);
      return <Navigate to="/login" />;
    }
    return <Outlet />;
  };

  return handleGuard();
};
